module.exports = "<a (click)=\"onNeedHelpClick()\" class=\"flex-btn\">\n  <!-- <i class=\"fa fa-video-camera\" aria-hidden=\"true\"></i> -->\n  <!-- &nbsp; -->\n  Need help?\n</a>\n<div itpx-modal></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/solar/common/guidance/guidance.component.html
// module id = ./src/app/solar/common/guidance/guidance.component.html
// module chunks = main